import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { createCrossTabMiddleware, mountCrossTabListener } from "utils/crossTabSync";
import { reconcileExternalEditsMiddleware } from "./middlewares/reconcileExternalEditsMiddleware";
import { debugLogColumnsMiddleware } from "./middlewares/debugLogColumnsMiddleware";

const composeEnhancers =
  (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const crossTabMiddleware = createCrossTabMiddleware();
const middlewares = [thunk, reconcileExternalEditsMiddleware, crossTabMiddleware];

if (process.env.NODE_ENV !== "production") {
  middlewares.splice(1, 0, debugLogColumnsMiddleware);
}

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middlewares))
);

mountCrossTabListener(store);

export default store;